import { useState } from 'react';

/**
 * 주소·명령을 클립보드로. 온보딩 화면은 "읽고 그대로 붙여넣는" 화면이라 복사가 기본 동작이다.
 * 복사 성공 표시는 잠깐만 띄우고 되돌린다 — 상태를 남겨 봐야 다음 복사와 헷갈린다.
 */
export function CopyButton({ value, label }: { value: string; label?: string }): React.JSX.Element {
  const [copied, setCopied] = useState(false);

  const copy = async (): Promise<void> => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1200);
  };

  return (
    <button
      type="button"
      onClick={() => void copy()}
      title={`복사 — ${value}`}
      className="cursor-pointer rounded border border-line px-1.5 py-0.5 text-[11px] text-muted hover:border-accent-line hover:text-accent"
    >
      {copied ? '복사됨' : (label ?? '복사')}
    </button>
  );
}
